import { getCustomerCard } from '@shared/modules/cross-seller/services/getCustomerCard';
import { IAxiosError } from '@shared/types/AxiosError';
import { useQuery } from '@tanstack/react-query';

import { IGetCustomerCard } from '../services';

export function useGetCustomerCard(companyId: string) {
  const { data, isLoading, isFetching, error, ...query } = useQuery(
    ['getCustomerCard'],
    () => getCustomerCard(companyId),
  );

  return {
    data: data?.data || ([] as IGetCustomerCard[]),
    isFindingCustomerCard: isLoading || isFetching,
    errorFindingCustomerCard: error as IAxiosError,
    ...query,
  };
}
